import { createSelector } from 'reselect';

import type InvoiceAdjustment from '~/types/InvoiceAdjustment';

import { type ApplicationState } from '~/store';

const getInvoiceAdjustmentsStore = (state: ApplicationState) => state.invoiceAdjustments;

export const getDisplayInvoiceAdjustments = createSelector(
  getInvoiceAdjustmentsStore,
  (invoiceAdjustmentsStore): Requestable<InvoiceAdjustment[], string> =>
    invoiceAdjustmentsStore.displayInvoiceAdjustments,
);
